// The one place that decides where "home" is. Home is the `/dashboard` route for everyone, whatever the `readyList`
// switch says. The switch decides what that route draws: the ready list, or the worklist for a nurse and with the
// switch OFF (main's default). Every home door (the rail's Today tile, the logo, the index route
// `/`, the error and 404 pages' "Go to Today", the encounter's "Back to Today") opens `/dashboard`, and `/today` itself
// redirects there (router.tsx, TodayRedirect). What `/dashboard` draws is decided in dashboard-page.tsx, never the route.
export const READY_LIST_HOME = '/dashboard';

/** Home, for every caller. Kept as a function so the callers below stay one shape. */
export function homePath(): string {
  return READY_LIST_HOME;
}

/** For code outside React's render (the app-level error boundary, a class above the router). */
export function readHomePath(): string {
  return homePath();
}

/** Home for this mount. */
export function useHomePath(): string {
  return homePath();
}
